<!--
 * @Description: 缴费方式组件
--> 
<template>
  <div class="article-detail">
    <van-nav-bar v-show="$comm.titleShow()" left-text="返回" :title="title" @click-left="$comm.onClickLeft" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <pay-way :article="article" :title="title"></pay-way>
  </div>
</template>

<script>
import PayWay from './PayWay'
export default {
  name: 'ArticleDetail',
  components: {
    PayWay
  },
  data() {
    return {
      article: {
        tit: ''
      },
      title: ''
    }
  },
  mounted() {
    if (this.$route.query.title) {
      this.title = this.$route.query.title
    } else {
      this.title = this.$route.meta.title
    }
    this.getArticleData()
  },
  methods: {
    getArticleData() {
      let params = {
        "fid": this.$route.query.fid,
      }
      this.$http.post(this.$api.getArticle, params).then(res => {
        if (res.code === '000') {
          this.article = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>